import * as breakpoint from '@pixelunion/breakpoint';
import GroupedContent from '@pixelunion/grouped-content';
import fitvids from 'fitvids';

export default class RTE {
  constructor(el) {
    this.el = el;
    this.originalContent = el.innerHTML;

    this.groupedContent = null;

    const initContent = () => {
      if (breakpoint.min('L')) {
        this._initGroupedContent('tabs');
      } else {
        this._initGroupedContent('accordion');
      }
    };

    // Tabs form a visual border so styling needs updating if they
    // are the first element in a container.
    if (this.el.firstElementChild && this.el.firstElementChild.classList.contains('tabs')) {
      this.el.parentNode.classList.add('no-border');
    }

    initContent();
    fitvids('.rte');

    breakpoint.onChange(({previous, current}) => {
      if (previous !== 'L' && current !== 'L') return;
      initContent();
    });
  }

  _resetContent() {
    if (!this.groupedContent) return;
    this.groupedContent.unload();
    this.el.innerHTML = this.originalContent;
  }

  _initGroupedContent(layout) {
    this._resetContent();
    this.groupedContent = new GroupedContent(this.el, { layout });
  }

  unload() {
    if (this.groupedContent) {
      this.groupedContent.unload();
    }
  }
}
